export enum EditOption {
  CHANGE_PARAMS = 'change_params',
  CHANGE_AUTH = 'change_auth',
}
